import React from "react";
import ToggleButton, { ToggleButtonProps } from "@mui/material/ToggleButton";
import { tss } from "tss-react/mui";

const useStyles = tss.create(({ theme }) => ({
  root: {
    padding: "11px 16px 9px",
    color: theme.palette.text.primary,
    fontSize: 16,
    backgroundColor: theme.palette.grey[50],
    textTransform: "none",
    transition: theme.transitions.create([
      "color",
      "background-color",
      "border-color",
    ]),
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.common.white,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.common.white,
    },
    "&.dark": {
      backgroundColor: theme.palette.grey.A100,
    },
  },
}));

interface Props {
  dark?: boolean;
}

type StyledToggleButtonProps = Props & ToggleButtonProps;

const StyledToggleButton = React.forwardRef<
  HTMLButtonElement,
  StyledToggleButtonProps
>(({ dark, children, ...rest }, ref) => {
  const { classes, cx } = useStyles();

  return (
    <ToggleButton
      ref={ref}
      className={cx(classes.root, { dark })}
      disableRipple
      {...rest}>
      {children}
    </ToggleButton>
  );
});

StyledToggleButton.displayName = "StyledToggleButton";

export { StyledToggleButton };
